export type DashboardWorkspace = "client" | "agent" | "talent";

type Capabilities = {
  isBooker: boolean;
  isAgent: boolean;
  isTalent: boolean;
};

// Explicit, authorized URLs win. Bare dashboard links keep their legacy default.
export const dashboardWorkspace = (
  pathname: string,
  user: Capabilities,
): DashboardWorkspace | undefined => {
  const requested = pathname.match(
    /^\/dashboard\/(client|agent|talent)(?:\/|$)/,
  )?.[1];
  const allowed = {
    client: user.isBooker,
    agent: user.isAgent,
    talent: user.isTalent,
  };
  if (requested && allowed[requested as DashboardWorkspace]) {
    return requested as DashboardWorkspace;
  }
  if (user.isBooker) return "client";
  if (user.isAgent) return "agent";
  if (user.isTalent) return "talent";
};

export const canCreateBooking = (user: {
  isBooker: boolean;
  isAgent: boolean;
  isFirstPartyAgent: boolean;
}) => user.isBooker || (user.isAgent && !user.isFirstPartyAgent);
